var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "face" }, [
    _c("div", { staticClass: "faceBack" }),
    _c("div", { staticClass: "faceDataDlo" }, [
      _c("div", { staticClass: "titleDialog" }, [
        _c("p", [_vm._v("人脸识别")]),
        _c("i"),
        !_vm.isTest
          ? _c("em", {
              staticClass: "el-icon-close detIcon",
              on: {
                click: function ($event) {
                  return _vm.isOpenShow()
                },
              },
            })
          : _vm._e(),
      ]),
      _vm.isSuccessful === ""
        ? _c(
            "div",
            { staticClass: "faceDiv" },
            [
              _c("p", [_vm._v("请衣着整齐，对准摄像头，并正对光源")]),
              _c("div", { staticClass: "faceData" }, [
                _c("div", { staticClass: "leftTop" }),
                _c("div", { staticClass: "rightTop" }),
                _c("div", { staticClass: "leftButton" }),
                _c("div", { staticClass: "rightButton" }),
                _c("i", { staticClass: "faceDataLine" }),
                _c("video", {
                  attrs: {
                    autoplay: "",
                    playsinline: "",
                    id: "video",
                    width: "333",
                    height: "333",
                  },
                }),
                _vm.count > 0
                  ? _c("div", { staticClass: "faceNumber" }, [
                      _vm._v(_vm._s(_vm.count)),
                    ])
                  : _vm._e(),
              ]),
              _c(
                "el-button",
                { staticClass: "refer-btn", attrs: { type: "primary" } },
                [_vm._v("人脸识别中...")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.isSuccessful === "audit"
        ? _c("div", { staticClass: "faceDivSuccessful" }, [
            _c("img", {
              staticClass: "auditImg",
              attrs: { src: require("@/assets/images/auditImg.png"), alt: "" },
            }),
            _c("p", [_vm._v("正在识别中请耐心等待...")]),
          ])
        : _vm._e(),
      _vm.isSuccessful === "successful"
        ? _c(
            "div",
            { staticClass: "faceDivSuccessful" },
            [
              _c("img", {
                attrs: {
                  src: require("@/assets/images/faceSuccessful.png"),
                  alt: "",
                },
              }),
              _vm._m(0),
              _c(
                "el-button",
                {
                  staticClass: "refer-btn",
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.isRouter()
                    },
                  },
                },
                [_vm._v("开始考试")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.isSuccessful === "failure"
        ? _c(
            "div",
            { staticClass: "faceDivSuccessful" },
            [
              _c("img", {
                attrs: { src: require("@/assets/images/faceErr.png"), alt: "" },
              }),
              _c("p", [
                _vm._v(" " + _vm._s(_vm.msgData) + " "),
                _c("br"),
                _vm._v(" 请拨打下方电话，联系管理员 "),
                _c("br"),
                _vm._v(" 023-62652911,023-62652917 "),
              ]),
              _c(
                "el-button",
                {
                  staticClass: "refer-btn",
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.setSuccessful()
                    },
                  },
                },
                [_vm._v("重新识别")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.isSuccessful === "equipment"
        ? _c(
            "div",
            { staticClass: "faceDivSuccessful" },
            [
              _c("img", {
                attrs: { src: require("@/assets/images/faceErr.png"), alt: "" },
              }),
              _c("strong", [_vm._v("浏览器未检测到摄像头")]),
              _c("p", [_vm._v("1、请确认是否安装可使用的摄像头")]),
              _c("p", { staticClass: "pButton" }, [
                _vm._v("2、请确认浏览器是否设置允许本网站调用摄像头"),
              ]),
              _c(
                "el-button",
                {
                  staticClass: "refer-btn",
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.setEquipment()
                    },
                  },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(" 已识别成功 "),
      _c("br"),
      _vm._v(" 点击下方按钮去开始考试 "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }